import { Modal } from "antd";

const TaskDetailsModalPopup = ({ visible, task, onClose }) => {
  if (!task) return null;

  return (
    <Modal title="Task Details" open={visible} onCancel={onClose} footer={null}>
      <div style={{ maxHeight: "340px", overflowY: "auto" }}>
        <p>
          <strong>Title:</strong> {task?.title}
        </p>
        <p>
          <strong>Description:</strong> {task?.description}
        </p>
        <p>
          <strong>Status:</strong> {task?.status}
        </p>
        <p>
          <strong>Priority:</strong> {task?.priority}
        </p>
        <p>
          <strong>Due Date:</strong>{" "}
          {task?.dueDate ? new Date(task?.dueDate).toLocaleDateString() : "N/A"}
        </p>
        <p className="d-flex gap-1">
          <strong>Assigned To:</strong>{" "}
          {task?.assignedTo.map((assignToUser, index) => {
            return (
              <div key={index} style={{ display: "flex", gap: "20px" }}>
                <p>
                  {assignToUser?.firstName} {assignToUser?.lastName},
                </p>
              </div>
            );
          })}
        </p>
        <p>
          <strong>Assigned By:</strong> {task?.assignedBy?.firstName}{" "}
          {task?.assignedBy?.lastName}
        </p>
      </div>
    </Modal>
  );
};

export default TaskDetailsModalPopup;